import { getPrinterMode, setPrinterMode } from "./printerModeCache";
/**
 * Ensures printer mode is confirmed before printing.
 * Returns true if safe to print, false if blocked.
 */
export const ensurePrinterMode = ({
    printerId,
    requiredLanguage,
    onRequireConfirm,
}) => {
    return new Promise((resolve) => {
        const lastMode = getPrinterMode(printerId);

        // already confirmed
        if (lastMode === requiredLanguage) {
            resolve(true);
            return;
        }

        // need confirmation
        onRequireConfirm(() => {
            setPrinterMode(printerId, requiredLanguage);
            resolve(true);
        });
    });
};
